import Aktiviteter = require("./GridAktiviteter");
import { Utils } from "../Utils";

export class AntallCab {
    planlagt: DevExpress.ui.dxDataGrid;
    produsert: DevExpress.ui.dxDataGrid;
    popup: DevExpress.ui.dxPopup;
    refresh: Function;
    planId: number;

    constructor(planId: number, refresh: Function) {
        const self: AntallCab = this;
        this.planId = planId;
        this.refresh = refresh;
        $.get("/templates/antallcab.html", (html) => {

            var title = Handlebars.compile($(html).filter("#tmpl-title").html());
            var tab = Handlebars.compile($(html).filter("#tmpl-tab").html());

            let popupContainer = $("<div>").attr("id", "confirmation")
                .dxPopup({
                    height: 600,
                    width: 600,
                    contentTemplate: html,
                    showCloseButton: false,
                    dragEnabled: false,
                    titleTemplate: title({title: "Antall fra CAB"})
                });
            popupContainer.appendTo($("body"));
            this.popup = popupContainer.dxPopup("instance");
            this.popup.show();

            $("#content").html(tab({}));

            $("#confirmation-planlagt").dxButton({
                text: "Lagre antall planlagt", type: "success", width: 200, height: 30,
                onClick: () => {
                    var selected = self.planlagt.getSelectedRowsData();
                    $.post('/Plan/SavePlanlagt',
                        { planId: self.planId, grupper: selected },
                        (ans) => {

                        }).always(() => {
                            popupContainer.remove();
                            setTimeout( () => self.refresh(), 500);
                    });
                }
            });
            $("#confirmation-produsert").dxButton({
                text: "Lagre antall produsert", type: "success", width: 200, height: 30,
                onClick: () => {
                    var selected = self.produsert.getSelectedRowsData();
                    $.post('/Plan/SaveProdusert',
                        { planId: self.planId, ordrer: selected },
                        (ans) => {

                        }).always(() => {
                            popupContainer.remove();
                            setTimeout(() => self.refresh(), 500);
                        });
                }
            });
            $("#confirmation-no").dxButton({
                text: "Lukk vindu", type: "normal", width: 200, height: 30,
                onClick: () => popupContainer.remove()
            });   

            this.createGrids();
       });
    }

    createGrids() {
        const self: AntallCab = this;
        Utils.wait('Laster ned fakturagrupper...');
        $.get('/Plan/CabFakturagruppe', {planId: this.planId}, 
            (data) => {

                self.planlagt = $("#cab-planlagt-grid").dxDataGrid({
                    dataSource: data,
                    rowAlternationEnabled: true,
                    columnAutoWidth: true,
                    filterRow: {
                        visible: true,
                        applyFilter: "auto"
                    },
                    headerFilter: {
                        visible: true
                    },
                    selection: {
                        mode: "multiple",
                        showCheckBoxesMode: "always"
                    },
                    paging: {
                        pageSize: 10
                    },
                    showBorders: true,
                    columns: [
                        {
                            dataField: 'fid',
                            caption: 'Fkt.gruppe',
                            width: 60
                        },
                        {
                            dataField: 'navn',
                            caption: 'Fakturagruppe navn',
                            width: 265
                        },
                        {
                            dataField: 'privat',
                            caption: 'Antall privat',
                            width: 90
                        },
                        {
                            dataField: 'naering',
                            caption: 'Antall næring',
                            width: 90
                        }
                    ]
                }).dxDataGrid("instance");

            }).always(() => Utils.finished());

        $.get('/Plan/CabOrdre', { planId: this.planId },
            (data) => {

                self.produsert = $("#cab-produsert-grid").dxDataGrid({
                    dataSource: data,
                    //height: 326,
                    width: 581,
                    rowAlternationEnabled: true,
                    columnAutoWidth: true, 
                    filterRow: {
                        visible: true,
                        applyFilter: "auto"
                    },
                    headerFilter: {
                        visible: true
                    },
                    selection: {
                        mode: "multiple",
                        showCheckBoxesMode: "always"
                    },
                    paging: {
                        enabled: true,
                        pageSize: 12
                    },
                    scrolling: {
                        //mode: "virtual",
                        //showScrollbar: "always",
                        useNative: true,
                    },
                    showBorders: true,
                    columns: [
                        {
                            dataField: 'nr',
                            caption: 'Ordre nr',
                            width: 60
                        },
                        {
                            dataField: 'navn',
                            caption: 'Ordre navn',
                            width: 250
                        },
                        {
                            dataField: 'privat',
                            caption: 'Antall privat',
                            width: 90
                        },
                        {
                            dataField: 'naering',
                            caption: 'Antall næring',
                            width: 90
                        }
                    ]
                }).dxDataGrid("instance");

            }).always(() => Utils.finished());
    }
}


// WEBPACK FOOTER //
// ./TS/Plan/AntallCab.ts